"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeToast = void 0;
var TypeToast;

(function (TypeToast) {
  /**
   * 토스트를 열어요
   * @required body 토스트 내용
   */
  TypeToast["ReqToastOpen"] = "REQ.TOAST.OPEN";
})(TypeToast = exports.TypeToast || (exports.TypeToast = {}));